<template>
    <Header12 />
    <div class="body">
        <section class="background-rose">
            <MenuTitle title="Bilan de" subTitle="compétences" srcImg="/images/pages/bilan-competences/menu_title.jpg"
                backgroundSpan="span-background-red" />
        </section>
        <section>
            <NavLeft tab="bilan-competences" breadcrumb1="" breadcrumb2="" />
        </section>
        <section class="background-rose">
            <ObjectifBilan />
        </section>
        <section>
            <StepsBilan />
        </section>
        <section class="background-rose">
            <SearchCenter />
        </section>
        <section>
            <BilanCompteur />
        </section>
        <section class="background-bleu">
            <AvisClient title="Ils ont fait un Bilan de Compétences et ils racontent :" :idCategory="80" />
        </section>
        <section>
            <NousContacter />
        </section>
        <section>
            <Footer :dark_bg="true" />
        </section>
    </div>
</template>
<script setup>
import Header12 from '~/components/common/Headers/Header-12.vue';
import MenuTitle from "../MenuTitle";
import NousContacter from '@/components/emci/NousContacter/index.vue'
import Footer from '@/components/emci/Footer/index.vue'
import NavLeft from "@/components/emci/NavLeft/index.vue"
import ObjectifBilan from "@/components/emci/BilanComptences/ObjectifBilan/index.vue"
import StepsBilan from "@/components/emci/BilanComptences/StepsBilan/index.vue"
import SearchCenter from "@/components/emci/BilanComptences/SearchCenter/index.vue"
import BilanCompteur from "@/components/emci/BilanComptences/BilanCompteur/index.vue"
import AvisClient from '@/components/emci/AvisClient/index.vue';
useHead({
    title: "Réalisez un bilan de compétences avec EMCI",
    meta: [
        {
            name: "description",
            content: "Vous voulez donner un nouvel élan à votre carrière ou envisagez de changer de métier ? EMCI vous accompagne pour réaliser un bilan de compétences grâce à son équipe de consultants"
        }
    ]
})
</script>
<style scoped>
.body {
    overflow: hidden !important;
    margin-top: 120px;
}

@media only screen and (min-width: 100px) and (max-width: 768px) {
    .body {
        margin-top: 85px;
    }

    .background-bleu {
        margin-bottom: 50px;
    }
}
</style>